import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { AuthPopup } from '@types';
import { AuthFooter, AuthFooterMessage, AuthLink } from '../components';
import { AuthFooterProps } from '../types';

export const OtpFooter: React.FC<AuthFooterProps> = ({ type, children }) => {
    const { t } = useTranslation();
    return (
        <AuthFooter>
            <AuthFooterMessage>
                <Trans
                    i18nKey="messages.passwordSignInLink"
                    components={{
                        ln: <AuthLink auth={AuthPopup.SignIn} type={type} />,
                    }}
                    defaults={'Have a password? <ln>Sign In</ln>'}
                />
            </AuthFooterMessage>

            {children}
        </AuthFooter>
    );
};
